<!--
    描述：电子保函管理入口页面
    Created by ws
-->
<template>
  <transition name="fade" mode="out-in">
    <!-- 用做缓存页面 -->
    <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "bh-letter-application",
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState("tags", {
      cachedViews: (state) => state.cacheTags,
    }),
    key() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped lang="less"></style>
